import { forEach } from "@uirouter/core";
import type { IScope } from "angular";
import type { IImageData } from "App/Modules/Models/Models/IImageData";

import type { IPoint } from "App/Modules/Models";

export default class EditVideoStreamComponentController {
    public static $inject: string[] = ["$scope", "mmSvgService"];

    public masks: IPoint[][];

    public image: IImageData;

    public selectedBlackMask: IPoint[];

    public newBlackMask: IPoint[];

    public editingBlackMasks = false;

    public addingBlackMask = false;

    public isEditable: boolean;

    constructor(private readonly $scope: IScope, private svgService: any) {}

    public $onInit() {
        this.setupWatches();
    }

    public addNewBlackMaskPoint(event: any) {
        const mousePosition: IPoint = {
            x: event.clientX,
            y: event.clientY,
        };

        const p = this.svgService.pointToSvgCoordinates(document.querySelector("#cameraSvg"), mousePosition);
        this.newBlackMask.push({ x: p.x, y: p.y });
    }

    public addBlackMask() {
        if (this.newBlackMask && this.isMaskComplete()) {
            this.masks.push(this.newBlackMask);
            this.editingBlackMasks = true;
            this.addingBlackMask = false;
            this.selectedBlackMask = null;
        }

        this.newBlackMask = null;
    }

    public deleteBlackMask(index: number) {
        this.masks.splice(index, 1);
        this.selectedBlackMask = null;
    }

    public editingBlackMask(index: number, editing: boolean) {
        if (editing) {
            forEach(this.masks, (blackMask: any, i: any) => {
                if (i !== index) {
                    blackMask.editing = false;
                }
            });
            this.selectedBlackMask = this.masks[index];
        } else {
            this.selectedBlackMask = null;
        }
    }

    public isMaskComplete(): boolean {
        return this.newBlackMask.length > 2;
    }

    private setupWatches() {
        this.$scope.$watch("$ctrl.editingBlackMasks", (newValue) => {
            if (newValue) {
                this.addingBlackMask = false;
                this.newBlackMask = [];
            }

            this.selectedBlackMask = [];
        });

        this.$scope.$watch("$ctrl.addingBlackMask", (newValue) => {
            if (newValue) {
                this.editingBlackMasks = false;
                this.selectedBlackMask = [];
            }

            this.newBlackMask = [];
        });
    }
}
